// extracted by mini-css-extract-plugin
export default {"bounce":"Profile_bounce__Tsrkk"};